module.exports = "<p>\n  document works!\n</p>\n"